import { formatMoney } from "./constants";

// Zajednički kontekst ekrana finansija: izabrani restoran (admin ga bira u glavnom
// meniju, restoran ima svoj), uloga i formatiranje novca.
export default {
  computed: {
    restaurantId() {
      return this.$store.state.restaurant?.id;
    },
    isAdmin() {
      return this.$store.state.user?.user?.type === "admin";
    },
  },

  methods: {
    // Valuta iz odgovora (princip 6), tek onda iz podešavanja restorana.
    money(value, currency, signed = false) {
      return formatMoney(value, currency || this.restaurantCurrency, { signed });
    },
  },
};
